import { Container, Group, ActionIcon, Text, rem } from '@mantine/core';
import { IconWorld, IconBrandYoutube, IconBrandLinkedin } from '@tabler/icons-react';
import classes from './footer.module.css';

function Footer() {
  return (
    <div className={classes.footer}>
      <Container className={classes.inner} fluid>
        <Group gap={rem(20)} className={classes.links}>
          <ActionIcon
            size="xl"
            color="btb-navy"
            variant="filled"
            radius="xl"
            component="a"
            href="https://robfinlay.com/"
            target="_blank"
            className={classes.anchor}
          >
            <IconWorld stroke={1.5} size={36} />
          </ActionIcon>
          <ActionIcon
            size="xl"
            color="btb-navy"
            variant="filled"
            radius="xl"
            component="a"
            href="https://www.linkedin.com/in/rob-j-finlay/"
            target="_blank"
            className={classes.anchor}
          >
            <IconBrandLinkedin stroke={1.5} size={36} />
          </ActionIcon>
          <ActionIcon
            size="xl"
            color="btb-navy"
            variant="filled"
            radius="xl"
            component="a"
            href="https://www.youtube.com/@Robjfinlay"
            target="_blank"
            className={classes.anchor}
          >
            <IconBrandYoutube stroke={1.5} size={36} />
          </ActionIcon>
        </Group>
      </Container>

      <Text ta="right" className={classes.buildText}>
        (mode: {import.meta.env.MODE} &nbsp;build: {import.meta.env.COMMIT_HASH})
      </Text>
    </div>
  );
}

export { Footer };
